import React, { ReactNode } from 'react';

import IbTooltip from '../IbTooltip';

import './index.less';

const MAIN_CLASS_NAME = 'switcher';
const BUTTON_CLASS_NAME = `${MAIN_CLASS_NAME}__button`;
const SELECTED_BUTTON_CLASS_NAME = `${BUTTON_CLASS_NAME}_selected`;

export interface ISwitcherOption {
  value: string | boolean;
  label: ReactNode;
  title?: string;
  tooltip?: string;
}

export interface ISwitcherProps {
  className?: string;
  value?: string | boolean | null;
  options?: ISwitcherOption[];
  onChange?: (value: string | boolean) => void;
}

const Switcher: React.FC<ISwitcherProps> = ({ className, value, options, onChange }) => {
  const classes = [MAIN_CLASS_NAME];
  className && classes.push(className);

  const onButtonClick = (value: string | boolean) => () => onChange?.(value);

  const renderOption = (option: ISwitcherOption, index: number) => {
    return (
      <div
        key={index}
        className={`${BUTTON_CLASS_NAME} ${value == option.value ? SELECTED_BUTTON_CLASS_NAME : ''}`.trim()}
        title={option.title}
        onClick={onButtonClick(option.value)}
      >
        {option.label}
      </div>
    );
  };

  return (
    <div className={classes.join(' ')}>
      {options?.map((option, index) =>
        option.tooltip ? (
          <IbTooltip key={index} placement="bottom" title={option.tooltip}>
            {renderOption(option, index)}
          </IbTooltip>
        ) : (
          renderOption(option, index)
        )
      )}
    </div>
  );
};

export default Switcher;
